import { useForm } from 'react-hook-form';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DefectAutoLinkPatternFields from './DefectAutoLinkPatternFields';
import { AutoLinkPattern, AutoLinkPatternDialogAction } from '../types';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { useEffect } from 'react';

interface FormValues {
    pattern: AutoLinkPattern;
}

interface DefectAutoLinkPatternDialogProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: AutoLinkPattern, action: AutoLinkPatternDialogAction) => void;
    action: AutoLinkPatternDialogAction;
    defaultValues: FormValues;
}

const DefectAutoLinkPatternDialog = ({
    open,
    onClose,
    onSubmit,
    defaultValues,
    action,
}: DefectAutoLinkPatternDialogProps) => {
    const { t } = useTranslation();
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors, isDirty },
    } = useForm<FormValues>({
        defaultValues,
    });

    const handleClose = () => {
        reset();
        onClose();
    };

    const handleFormSubmit = (data: FormValues) => {
        onSubmit(data.pattern, action);
        handleClose();
    };

    useEffect(() => {
        if (open) {
            reset(
                defaultValues ?? {
                    pattern: {
                        name: '',
                        errorMessagePattern: '',
                        stackTracePattern: '',
                    },
                },
            );
        }
    }, [open, defaultValues, reset]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ fontWeight: 700, fontSize: 16 }}>
                {t(action)} {t('automation_rule')}
            </DialogTitle>
            <DialogContent sx={{ overflow: 'visible' }}>
                <DefectAutoLinkPatternFields basePath="pattern" control={control} errors={errors} />
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleSubmit(handleFormSubmit)} disabled={!isDirty}>
                    {t('save')}
                </UtmsButton>
                <UtmsButton onClick={handleClose} color="secondary">
                    {t('cancel')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default DefectAutoLinkPatternDialog;
